<template>
  <div style="transition: 0.4s;" class="w-1/4 flex-1 bg-white rounded-xl space-y-6 p-6 tip-block" :class="`step${ nowStep }`">
    <p v-html="content"></p>
    <div class="tip-footer">
      <button
        :style="{ opacity: nowStep === 45 ? 1 : 0 }"
        class="hover:bg-blue-100 focus:outline-none rounded-xl px-4 py-1 text-blue-400 transition duration-500 ease-in-out border-blue-400 border-2"
        :disabled="nowStep === 1"
        @click="closeTips()"
      >
        {{closeTipsText}}
      </button>
      <button
        v-if="nowStep === 49"
        class="hover:bg-yellow-200 focus:outline-none rounded-xl px-4 py-1 text-blue-800 transition duration-500 ease-in-out border-yellow-400 border-2 bg-yellow-300"
        @click="next()"
      >
        {{finishText}}
      </button>
      <button
        v-else
        class="hover:bg-green-200 focus:outline-none rounded-xl px-4 py-1 text-white transition duration-500 ease-in-out border-green-400 border-2 bg-green-400"
        @click="next()"
      >
        {{nextText}}
      </button>

    </div>
  </div>
</template>

<script>
import * as contentData from '@/components/Tips/positionAndDeviceTips.json';

export default {
  name: 'PositionAndDeviceTips',
  props: {
    nowStep: {
      type: Number,
      default: 1
    },
    selectLang: {
      type: String
    }
  },
  data() {
    return {
      nextText: '下一步',
      finishText: '完成',
      closeTipsText: '跳過教學'
    }
  },
  computed: {
    content() {
      const data = contentData.default.filter(e => e.step === this.nowStep);
      let message;
      if (data.length > 0) {
        message = data[0].content_zh_TW;
        if(this.selectLang == 'zh-CN'){
          this.nextText = '下一步';
          this.finishText = '完成';
          this.closeTipsText = '跳过教学';

          message = data[0].content_zh_CN;
        }
        if(this.selectLang == 'en-US'){
          this.nextText = 'next';
          this.finishText = 'finish';
          this.closeTipsText = 'skip teaching';

          message = data[0].content_en_US;
        }
      } else {
        message = '';
      }
      return message;
    }
  },
  methods: {
    next() {
      this.$emit('nextStep');
      // this.nowStep = this.nowStep + 1;
    },
    closeTips() {
      this.$emit('closeTips');
    }
  }
};

</script>

<style lang="scss">

.tip-block {
  box-shadow: 4px 8px 16px 4px rgba(135, 135, 135, 0.6);
  z-index: 100;
}

.step45 {
  position: absolute;
  top: 35vh;
  left: 50vw;
}

.step46 {
  position: absolute;
  top: 35vh;
  left: 50vw;
}

.step47 {
  position: absolute;
  top: 35vh;
  left: 50vw;
}

.step48 {
  position: absolute;
  top: 35vh;
  left: 50vw;
}

.step49 {
  position: absolute;
  top: 35vh;
  left: 50vw;
}

.tip-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

</style>
